import { Checkbox, Grid } from "@mui/material";
import {useState} from "react";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MultipleSelectChip from "../../../UserScreen/HubDetails/Topology/MultipleSelectChip";
import "./MultiSelectAccordian.css";

interface MultiSelectionProps {
    defaultSelection?: string[];
    values?: string[];
    cardsCount?: number;
    handleSelection?: (value: string[]) => void;
    name?: string;
    limitValue?: number;
}

const MultiSelectAccordian = (props: MultiSelectionProps) => {
    const {defaultSelection, values, handleSelection, cardsCount, name, limitValue} = props;
    const [multiSelectOpen, setMultiSelectOpen] = useState(false);
    return(
        <div>
            
            <Grid className="filters-fields-container">
                <Checkbox size="small" sx={{ transform: "scale(0.8)" }} checked={multiSelectOpen} onChange={() => setMultiSelectOpen(!multiSelectOpen)} />
                <div className="fields-title-header">
                    <span className="filter-fields-title">{name}</span>
                    {multiSelectOpen ? (
                        <KeyboardArrowDownIcon onClick={() => setMultiSelectOpen(prevState => !prevState)} style={{cursor:"pointer"}}/>
                    ) : (
                        <KeyboardArrowUpIcon onClick={() => setMultiSelectOpen(prevState => !prevState)} style={{cursor:"pointer"}}/>
                    )}
                </div>
            </Grid>
            {multiSelectOpen && <MultipleSelectChip defaultSelection={defaultSelection??[]} values={values??[]} handleSelection={handleSelection} cardsCount={cardsCount} name={name??""} limitValue={limitValue??0} />}
        </div>
    )
}

export default MultiSelectAccordian;